(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
  // <!-- Initialize Swiper -->
  const vmHasSliderSwiperCollection = new Swiper('.vm-hasSlider-in-collection-js', {
    slidesPerView: 1,
    spaceBetween: 10,
    // loop: true,
    // speed: 3000,
    // autoplay: {
    //   delay: 1000,
    //   disableOnInteraction: false
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 2.5,
        spaceBetween: 15
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
  // <!-- Initialize Swiper -->
  const vmHasSliderSwiperProduct = new Swiper('.vm-hasSlider-in-product-js', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section-new"] && !Shopify.designMode) return;
  try {
    
  // Initialize Swiper
  const swiper = new Swiper('.vm-hasSlider-js', {
    centeredSlides: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    loop: true,
    effect: 'fade',
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
  // <!-- Initialize Swiper -->
  // Wait for DOMContentLoaded: Swiper is loaded with defer from layout/theme.liquid.
  document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;
  const swiper = new Swiper('.vm-hasSlider-js', {
    // spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    loop: true,
    effect: 'fade',
    // pagination: {
    // el: ".swiper-pagination",
    // clickable: true,
    // },
    // navigation: {
    // nextEl: ".swiper-button-next",
    // prevEl: ".swiper-button-prev",
    // },
  });
  });

  document.addEventListener('DOMContentLoaded', function () {
    function updateRightPoition_Section_2() {
      let widthOf_hasOverlay = document.querySelector('.vm-section-2 .vm-hasOverlay-img');
      const width = `${widthOf_hasOverlay.offsetWidth}px`;
      // console.log('width:', width);
      document.documentElement.style.setProperty('--vm-hasOverlay-img-2', width);
    }

    // Initial setting on document load
    updateRightPoition_Section_2();

    // Update on window resize
    window.addEventListener('resize', updateRightPoition_Section_2);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  // <!-- Initialize Swiper -->
// const collection_tabs_swiper = new Swiper('.collection_tabs-1-js', {
// slidesPerView: 1,
// spaceBetween: 10,
// pagination: {
// el: '.swiper-pagination',
// clickable: true
// },
// breakpoints: {
// 320: {
// slidesPerView: 2,
// spaceBetween: 20,
// grid: {
// rows: 2,
// fill: 'row'
// }
// },
// 540: {
// slidesPerView: 2,
// spaceBetween: 20,
// grid: {
// rows: 2,
// fill: 'row'
// }
// },
// 768: {
// slidesPerView: 2,
// spaceBetween: 40,
// grid: {
// rows: 2,
// fill: 'row'
// }
// },
// 1024: {
// slidesPerView: 4,
// spaceBetween: 40,
// grid: {
// rows: 1
// }
// }
// }
// });

  document.addEventListener("DOMContentLoaded", function() {
    const shopNowBtn = document.getElementById("shopNowBtn");
    const tabs = document.querySelectorAll("#dynamicTab .nav-link");

    tabs.forEach(tab => {
      tab.addEventListener("shown.bs.tab", function(e) {
        const link = e.target.getAttribute("data-shop-link");
        shopNowBtn.setAttribute("href", link);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
    function initBannerSwiper() {
      console.log("Initializing Banner Swiper");
      if (document.querySelector(".banner-section")) {
        console.log("Banner Swiper found, initializing...");
        // If Swiper already exists, destroy it first
        if (window.bannerSwiper && window.bannerSwiper.destroy) {
          window.bannerSwiper.destroy(true, true);
        }

        window.bannerSwiper = new Swiper(".banner-section", {
          slidesPerView: 1,
          loop: true,
          grabCursor: true,
          speed: 1000,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          on: {
            slideChangeTransitionStart() {
              document.querySelectorAll(".swiper-pagination-bullet").forEach((el) => {
                el.classList.remove("swiper-pagination-bullet-active");
                el.style.removeProperty("animation");
                el.innerHTML = "";
              });

              const activeBullet = document.querySelectorAll(".swiper-pagination-bullet")[window.bannerSwiper.realIndex];
              if (activeBullet) {
                activeBullet.classList.add("swiper-pagination-bullet-active");
              }
            }
          }
        });
      }
    }

    document.addEventListener("DOMContentLoaded", initBannerSwiper);
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        if (url.includes("/home") || url === window.location.origin + "/") {
          initBannerSwiper();
        }
      }
    }).observe(document, { subtree: true, childList: true });

    document.addEventListener("DOMContentLoaded", function () {
      setInterval(() => {
        const source = document.querySelector('#ProductCount');
        const target = document.querySelector('.update_product_count-js');

        if (source && target) {
          target.innerText = source.innerText;
        }
      }, 100);

      // Pdp sticky button -- start
      const isProductHasVariants = document.querySelector('variant-selects');
      const stickyButton = document.querySelector('.sticky_cta-button-js');
      const stickyButtonWrapper = document.querySelector('.sticky_cta-button-wrapper-js');
      const buyNowButton = document.querySelector('.shopify-payment-button__button');

      if(isProductHasVariants){
        console.log("Product has variants.");
      }else {
        console.log("Product has no variants.");
        stickyButton.addEventListener('click', function() {
          const addToCartBtn = document.querySelector('.product-form__submit');
          if(addToCartBtn){
            addToCartBtn.click();
          } else {
            console.warn("Buy Now button not found.");
          }
        });
      }

      window.addEventListener('scroll', handleStickyCtaScroll);
      handleStickyCtaScroll();
      function handleStickyCtaScroll() {
        if(stickyButton){

          const buyNowButtonTop = buyNowButton.getBoundingClientRect().top;
          const buyNowButtonHeight = buyNowButton.offsetHeight;
          const buyNowButtonBottom = buyNowButtonTop + buyNowButtonHeight;

          const stickyButtonTop = stickyButton.getBoundingClientRect().top;
          const stickyButtonHeight = stickyButton.offsetHeight;
          const stickyButtonBottom = stickyButtonTop + stickyButtonHeight;

          const windowTop = window.scrollY;

          const footerTop = document.querySelector('.site-footer').getBoundingClientRect().top;

          if(buyNowButtonBottom < 280){
            showStickyButton();
          }else {
            hideStickyButton();
          }


          // if((stickyButtonBottom < (footerTop + 200)) && buyNowButtonBottom < 0){
          //   showStickyButton();
          // }else {
          //   hideStickyButton();
          // }
        }
      }

      function hideStickyButton() {
        stickyButtonWrapper.classList.remove('active');
      }

      function showStickyButton() {
        stickyButtonWrapper.classList.add('active');
      }
      // Pdp sticky button -- end
    });

    document.addEventListener("DOMContentLoaded", function () {
      const menuItems = document.querySelectorAll('.header__menu-item-js');

      // Step 1: Get collection name from URL
      const pathParts = window.location.pathname.split('/');
      const collectionIndex = pathParts.indexOf('collections');
      const collectionHandle = collectionIndex !== -1 ? pathParts[collectionIndex + 1] : null;

      if (collectionHandle === 'all','dining','cookware','tea-coffee-essentials','home-and-kitchen','gifts-under-15-000','kansa','tamba','peetal') {
        localStorage.setItem('menu_group', 'all-group');
        localStorage.setItem('menu_group_item', 'all');
        showAllCollectionsList(); // Handle /collections/all case
      }
       else if (collectionHandle) {
        menuItems.forEach(item => {
          const group = item.getAttribute('data-menu-group');
          const groupItem = item.getAttribute('data-menu-group-item');

          // Step 2: Normalize groupItem to match the handle
          const normalizedGroupItem = normalizeText(groupItem);

          if (normalizedGroupItem === collectionHandle) {
            // Step 3: Store match in localStorage
            localStorage.setItem('menu_group', group);
            localStorage.setItem('menu_group_item', groupItem);

            // Step 4: Show only matching tab
            toggleFilterTabs(group);
          }

          // Step 5: Store on click
          item.addEventListener('click', function () {
            localStorage.setItem('menu_group', group);
            localStorage.setItem('menu_group_item', groupItem);

            toggleFilterTabs(group);
          });
        });
      }

      // Helper: Normalize text (replace & → and, space → -, lowercase)
      function normalizeText(str) {
        return str
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/\s+/g, '-');
      }

      // Helper: Toggle filter tabs
      function toggleFilterTabs(activeKey) {
        const allTabs = document.querySelectorAll('.filter_tabs_display-js');

        allTabs.forEach(tab => {
          const tabKey = tab.getAttribute('data-filter_tabs');

          if (tabKey === activeKey) {
            tab.classList.add('d-none');
          } else {
            tab.classList.remove('d-none');
          }
        });

        // Also hide the main collection list if filtering is applied
        document.querySelector('.collection_list-js')?.classList.add('d-none');
      }

      // New Helper: Show all collections list (for /collections/all)
      function showAllCollectionsList() {
        const collectionList = document.querySelector('.collection_list-js');
        if (collectionList) {
          collectionList.classList.remove('d-none');
        }

        // Optionally hide all filter tabs
        const allTabs = document.querySelectorAll('.filter_tabs_display-js');
        allTabs.forEach(tab => {
          const tabKey = tab.getAttribute('data-filter_tabs');
          if (tabKey === 'shop-by-metal') {
               tab.classList.remove('d-none');
          } else {
               tab.classList.add('d-none');
          }
        });
      }
    });

    /* =========================================================
       FILTER TAB CONFIG  (separate, self-contained script)
       Map each collection handle (part after /collections/)
       to the filter tab that page should show.

       Options:  'shop-by-metal'  |  'shop-by-collections'
       Add one line per collection. Anything not listed falls
       back to DEFAULT_FILTER_TAB.
       ========================================================= */
    document.addEventListener("DOMContentLoaded", function () {
      const FILTER_TAB_CONFIG = {
        // shop by metal
        'kansa':                   'shop-by-collections',
        'tamba':                   'shop-by-collections',
        'peetal':                  'shop-by-collections',

        // shop by collections
        'dining':                  'shop-by-metal',
        'cookware':                'shop-by-metal',
        'tea-coffee-essentials':   'shop-by-metal',
        'home-and-kitchen':        'shop-by-metal',
        'gifts-under-15-000':      'shop-by-metal',
        'all':                     'shop-by-metal',
      };

      const DEFAULT_FILTER_TAB = 'shop-by-metal';

      /* ---------- logic below — no need to edit ---------- */

      function getCollectionHandleFTC() {
        const parts = window.location.pathname.split('/').filter(Boolean);
        const idx = parts.indexOf('collections');
        return idx !== -1 && parts[idx + 1] ? parts[idx + 1] : null;
      }

      function applyFilterTabFTC() {
        const tabs = document.querySelectorAll('.filter_tabs_display-js');
        if (!tabs.length) return;

        const handle = getCollectionHandleFTC();
        const chosen = (handle && FILTER_TAB_CONFIG[handle]) || DEFAULT_FILTER_TAB;

        tabs.forEach(function (tab) {
          const key = tab.getAttribute('data-filter_tabs');
          if (key === chosen) {
            tab.classList.remove('d-none');
          } else {
            tab.classList.add('d-none');
          }
        });
      }

      applyFilterTabFTC();

      // Re-apply if facets re-render after AJAX filter/sort, or if the
      // other collection-detection script re-toggles the tabs.
      const scope = document.querySelector('.facets-container') || document.body;
      new MutationObserver(applyFilterTabFTC).observe(scope, {
        childList: true,
        subtree: true
      });
    });

    document.addEventListener("DOMContentLoaded", function () {
      let relatedIntervalId = setInterval(() => {
        const relatedProducts = document.querySelector('.related-products-swiper-js');

        if (relatedProducts) {
          clearInterval(relatedIntervalId);

          new Swiper('.related-products-swiper-js', {
            grabCursor: true,
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 10,
            // autoplay: {
            //   delay: 3000,
            //   disableOnInteraction: false
            // },
            breakpoints: {
              360: {
                slidesPerView: 1.5,
                spaceBetween: 20,
              },
              560: {
                slidesPerView: 2.3,
                spaceBetween: 20,
              },
              767: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1220: {
                slidesPerView: 4,
                spaceBetween: 20,
              }
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
          });

           new Swiper('.simple-swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            autoplay: {
              delay: 3000,
            },
          });
        }
      }, 500);
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        // this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  const site_header_js = document.getElementById('site-header-js');
  const vm_big_logo_js = document.getElementById('vm-big-logo-js');
  const vm_small_logo_js = document.getElementById('vm-small-logo-js');

  let previousScrollPosition = window.scrollY || window.pageYOffset;

  document.addEventListener('scroll', () => {
    const currentScrollPosition = window.scrollY || window.pageYOffset;

    // Downward scrolling
    if (currentScrollPosition > previousScrollPosition) {
      if (currentScrollPosition > 300) {
        site_header_js.classList.add('vm-header--hide');
      } else {
        site_header_js.classList.remove('vm-header--hide');
      }
    } else {
      if (currentScrollPosition <= 300) {
        site_header_js.classList.remove('vm-header--hide');
        site_header_js.classList.remove('vm-header--active');
      } else {
        site_header_js.classList.remove('vm-header--hide');
        site_header_js.classList.add('vm-header--active');

      }
    }

    previousScrollPosition = currentScrollPosition;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // class StickyHeader extends HTMLElement {
  //   constructor() {
  //     super();
  //   }

  //   connectedCallback() {
  //     this.header = document.querySelector('.section-header');
  //     this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  //     this.headerBounds = {};

  //     this.setHeaderHeight();

  //     window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  //     if (this.headerIsAlwaysSticky) {
  //       this.header.classList.add('shopify-section-header-sticky');
  //     };

  //     this.currentScrollTop = 0;
  //     this.preventReveal = false;
  //     this.predictiveSearch = this.querySelector('predictive-search');

  //     this.onScrollHandler = this.onScroll.bind(this);
  //     this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  //     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.addEventListener('scroll', this.onScrollHandler, false);

  //     this.createObserver();
  //   }

  //   setHeaderHeight() {
  //     document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  //   }

  //   disconnectedCallback() {
  //     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.removeEventListener('scroll', this.onScrollHandler);
  //   }

  //   createObserver() {
  //     let observer = new IntersectionObserver((entries, observer) => {
  //       this.headerBounds = entries[0].intersectionRect;
  //       observer.disconnect();
  //     });

  //     observer.observe(this.header);
  //   }

  //   onScroll() {
  //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  //     if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (this.preventHide) return;
  //       requestAnimationFrame(this.hide.bind(this));
  //     } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (!this.preventReveal) {
  //         requestAnimationFrame(this.reveal.bind(this));
  //       } else {
  //         window.clearTimeout(this.isScrolling);

  //         this.isScrolling = setTimeout(() => {
  //           this.preventReveal = false;
  //         }, 66);

  //         requestAnimationFrame(this.hide.bind(this));
  //       }
  //     } else if (scrollTop <= this.headerBounds.top) {
  //       this.header.classList.remove('scrolled-past-header');
  //       requestAnimationFrame(this.reset.bind(this));
  //     }

  //     this.currentScrollTop = scrollTop;
  //   }

  //   hide() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  //     this.closeMenuDisclosure();
  //     this.closeSearchModal();
  //   }

  //   reveal() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-sticky', 'animate');
  //     this.header.classList.remove('shopify-section-header-hidden');
  //   }

  //   reset() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  //   }

  //   closeMenuDisclosure() {
  //     this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  //     this.disclosures.forEach(disclosure => disclosure.close());
  //   }

  //   closeSearchModal() {
  //     this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  //     this.searchModal.close(false);
  //   }
  // }

  // customElements.define('sticky-header', StickyHeader);

  // const site_header_js = document.getElementById('site-header-js');
  // const vm_big_logo_js = document.getElementById('vm-big-logo-js');
  // const vm_small_logo_js = document.getElementById('vm-small-logo-js');

  // let previousScrollPosition = window.scrollY || window.pageYOffset;

  // document.addEventListener('scroll', () => {
  //   const currentScrollPosition = window.scrollY || window.pageYOffset;

  //   // Downward scrolling
  //   if (currentScrollPosition > previousScrollPosition) {
  //     if (currentScrollPosition > 50) {
  //       site_header_js.classList.add('vm-header--hide');
  //     } else {
  //       site_header_js.classList.remove('vm-header--hide');
  //     }
  //   } else {
  //     if (currentScrollPosition <= 50) {
  //       site_header_js.classList.remove('vm-header--hide');
  //       site_header_js.classList.remove('vm-header--active');
  //     } else {
  //       site_header_js.classList.remove('vm-header--hide');
  //       site_header_js.classList.add('vm-header--active');

  //     }
  //   }

  //   previousScrollPosition = currentScrollPosition;
  // });

  document.addEventListener("DOMContentLoaded", function () {
    const header = document.getElementById('site-header-js');
    const htmlElement = document.querySelector("html");
    const section4 = document.querySelector(".vm-section-4");

    function updateHeaderHeight() {
      if (header) {
        const headerHeight = `${header.offsetHeight}px`;
        document.documentElement.style.setProperty('--header-height-value', headerHeight);
      }
    }

    function changeScrollSnapType() {
      if (section4) {
        const homeSection_4_OffsetTop = section4.offsetTop;
        const windowOffsetTop = (window.pageYOffset || window.scrollY) + 100;
        if (window.innerWidth > 767) {
          if (windowOffsetTop >= homeSection_4_OffsetTop) {
            htmlElement.style.scrollSnapType = "none";
          } else {
            htmlElement.style.scrollSnapType = "y mandatory";
          }
        } else {
          htmlElement.style.scrollSnapType = "none";
        }
      }
    }


    // Initial setting on document load
    updateHeaderHeight();
    changeScrollSnapType();

    // Update on window resize
    window.addEventListener('resize', function () {
      updateHeaderHeight();
      changeScrollSnapType();
    });
    window.addEventListener('scroll', changeScrollSnapType);


    // document.querySelector('.hamburger-js').addEventListener('click', function(){
    //   console.log("Hello World!!!");
    //     const header = document.getElementById('site-header-js');
    //     const menuDrawer = document.querySelector('.menu-drawer-js');
    //     const body = document.querySelector('body');

    //     if(window.innerWidth > 767 && window.innerWidth <= 989){
    //       header.classList.toggle('header-brown--active');
    //     }else{
    //       header.classList.remove('header-brown--active');
    //     }
    //     menuDrawer.classList.toggle('open');
    //     body.classList.toggle('overflow-hidden');

    //     // Check if the menu is open and the click target is outside both the menuDrawer and the hamburger button
    //       if (
    //           menuDrawer.classList.contains('open') &&
    //           !menuDrawer.contains(event.target) &&
    //           !hamburger.contains(event.target)
    //       ) {
    //           menuDrawer.classList.remove('open');
    //           document.body.classList.remove('overflow-hidden');
    //       }
    // });

      const hamburger = document.querySelector('.hamburger-js');
      const menuDrawer = document.querySelector('.menu-drawer-js');
      const body = document.querySelector('body');

      // Toggle menu on hamburger click
      // hamburger.addEventListener('click', function(event) {
      //   // event.stopPropagation(); // prevent the document click handler from firing

      //   // console.log("Hello World!!!");

      //   if (window.innerWidth > 767 && window.innerWidth <= 989) {
      //     header.classList.toggle('header-brown--active');
      //   } else {
      //     header.classList.remove('header-brown--active');
      //   }

      //   if (menuDrawer && body) {
      //       menuDrawer.classList.toggle('open');
      //       body.classList.toggle('overflow-hidden');
      //     } else {
      //       console.warn('menuDrawer or body not found in the DOM.');
      //     }
      // });

      // Close menu if clicked outside
      // document.addEventListener('DOMContentLoaded', function () {
      //     const menuDrawer = document.querySelector('#menu-drawer');
      //     const hamburger = document.querySelector('.header__icon--menu'); // or your actual class/id
      //     const body = document.body;
      //     const header = document.querySelector('header'); // Adjust if needed

      //     if (!menuDrawer || !hamburger) return; // Safeguard to prevent null errors

      //     document.addEventListener('click', function (event) {
      //       const isClickInsideMenu = menuDrawer.contains(event.target);
      //       const isClickOnHamburger = hamburger.contains(event.target);

      //       if (!isClickInsideMenu && !isClickOnHamburger && menuDrawer.classList.contains('open')) {
      //         menuDrawer.classList.remove('open');
      //         body.classList.remove('overflow-hidden');
      //         header?.classList.remove('header-brown--active'); // Optional chaining
      //       }
      //     });

      // });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const intervalId = setInterval(() => {
      const chatIcon = document.querySelector('#whatsapp-chat-widget');
      const closeBtn = document.querySelector('.wa-chat-bubble-close-button');

      if (chatIcon && closeBtn) {
        // Check if it was previously closed
        if (localStorage.getItem('hideWhatsappChat') === 'true') {
          chatIcon.classList.add('d-none');
        }

        // Attach the click listener only once
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          chatIcon.classList.add('d-none');
          localStorage.setItem('hideWhatsappChat', 'true');
          console.log('WhatsApp widget closed by user');
        });

        clearInterval(intervalId); // Stop checking once found
      }
    }, 50);
  });

  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".section-header.shopify-section-group-header-group");
    const vmHeader = document.querySelector(".vm-header");
    let lastScrollTop = 0;
    const tolerance = 5; // px buffer to avoid flicker

    window.addEventListener("scroll", headerSticky);
    headerSticky();

    function headerSticky() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (Math.abs(scrollTop - lastScrollTop) <= tolerance) {
        return; // ignore tiny scroll changes
      }

      if (scrollTop > 200) {
        if (scrollTop > lastScrollTop) {
          // scrolling down
          if (!header.classList.contains("hide")) {
            header.classList.add("hide");
          }
          header.classList.remove("small_logo");
          vmHeader.classList.remove("vm-header--active");
        } else {
          // scrolling up
          header.classList.remove("hide");
          if (!header.classList.contains("small_logo")) {
            header.classList.add("small_logo");
          }
          vmHeader.classList.add("vm-header--active");
          if (vmHeader) {
            vmHeader.style.setProperty("background-color", "#ab745f", "important");
          }
        }
      } else {
        if (vmHeader) {
          vmHeader.style.setProperty("background-color", "transparent");
          header.classList.remove("small_logo");
          vmHeader.classList.remove("vm-header--active");
        }
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    settingLogo();
    function settingLogo() {
      const site_header_js = document.getElementById('site-header-js');
      const header__heading_logo_white = document.querySelector('.header__heading-logo-white');
      const header__heading_logo_brown = document.querySelector('.header__heading-logo-brown');

      if (window.innerWidth > 989) {
        site_header_js.classList.add('header--brown');
        site_header_js.classList.remove('header--white');

        header__heading_logo_white.classList.add('d-none');
        header__heading_logo_brown.classList.remove('d-none');
      }else{
        site_header_js.classList.remove('header--brown');
        site_header_js.classList.add('header--white');

        header__heading_logo_white.classList.remove('d-none');
        header__heading_logo_brown.classList.add('d-none');
      }
    }
    window.addEventListener('resize', settingLogo);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  const textOfTitle = document.querySelector('#collection-hero__title-js').innerText;
  if (textOfTitle.includes('&')) {
    const updatedTextOfTitle = textOfTitle.replace('&', 'and');
    document.querySelector('#collection-hero__title-js').innerText = '';
    document.querySelector('#collection-hero__title-js').innerText = updatedTextOfTitle;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    settingLogo();
    function settingLogo() {

      const site_header_js = document.getElementById('site-header-js');
      const header__heading_logo_white = document.querySelector('.header__heading-logo-white');
      const header__heading_logo_brown = document.querySelector('.header__heading-logo-brown');

      if (window.innerWidth > 989) {
        site_header_js.classList.add('header--brown');
        site_header_js.classList.remove('header--white');

        header__heading_logo_white.classList.add('d-none');
        header__heading_logo_brown.classList.remove('d-none');
      } else {
        site_header_js.classList.remove('header--brown');
        site_header_js.classList.add('header--white');

        header__heading_logo_brown.classList.add('d-none');
        header__heading_logo_white.classList.remove('d-none');
      }
    }
    window.addEventListener('resize', settingLogo);
  });


  document.addEventListener('DOMContentLoaded', function() {
    const removeFacets = document.querySelectorAll('facet-remove');
    const wrapper = document.querySelector('.material_filter-wrapper');
    if (! wrapper) return;
    

    const labels = wrapper.querySelectorAll('.material_filter-wrapper label');

    document.addEventListener('click', function(event) {
      const target = event.target.closest('facet-remove');
      if (target) {
        setTimeout(() => {
          onLoadToSetFilterActive();
        }, 500);
      }
    });

// Allow multiple checkboxes
// labels.forEach(label => {
// label.addEventListener('click', function() {
// setTimeout(() => {
// const label_filter_group = label.getAttribute('data-filter_group');
// console.log("label_filter_group:",label_filter_group);
// const input = label.querySelector('input[type="checkbox"]');
// if (! input) return;

// const nameAttr = input.id; // Get the input ID under this label
// const allSameNameInputs = document.querySelectorAll(`input[id="${nameAttr}"]`);

// allSameNameInputs.forEach(i => {
// if (wrapper.contains(i)) return;

// if (i.checked) { // console.log('check:', i.id);
// wrapperInputActive(i.id, label_filter_group);
// } else { // console.log('uncheck:', i.id);
// wrapperInputDeActive(i.id);
// }
// });
// }, 100);
// });
// });

// Allow single checkbox
    labels.forEach(label => {
      label.addEventListener('click', function() {
        setTimeout(() => {
          const label_filter_group = label.getAttribute('data-label_filter_group');
          const input = label.querySelector('input[type="checkbox"]');
          if (! input) return;
          

          const nameAttr = input.id;

// Now handle same-named inputs outside the wrapper (syncing logic)
          const allSameNameInputs = document.querySelectorAll(`input[id="${nameAttr}"]`);

          allSameNameInputs.forEach(i => {
            if (wrapper.contains(i)) return;
            

            if (i.checked) {
              wrapperInputActive(i.id);
            } else {
              wrapperInputDeActive(i.id);
            }
          });

// Select all inputs under the same group
          const groupInputs = document.querySelectorAll(`label[data-label_filter_group="${label_filter_group}"] input[type="checkbox"]`);

// Deactivate all inputs in this group except the current one
          groupInputs.forEach(i => {
            if (i.id !== nameAttr) {
              i.checked = false;
              wrapperInputDeActive(i.id);
            }
          });

// Scroll to top after handling logic
          window.scrollTo({top: 0, behavior: 'smooth'});
        }, 100);
      });
    });


    function onLoadToSetFilterActive() {
      const allSameNameInputs = document.querySelectorAll(`input[type="checkbox"]`);

      allSameNameInputs.forEach(i => {
        if (wrapper.contains(i)) return;
        

        if (i.checked) { // console.log('check:', i.id);
          wrapperInputActive(i.id);
        } else { // console.log('uncheck:', i.id);
          wrapperInputDeActive(i.id);
        }
      });
    }

    function wrapperInputActive(inputId) {
      const inputs = wrapper.querySelectorAll(`.material_filter-wrapper label input[id="${inputId}"]`);


      inputs.forEach(input => {
        const li = input.closest('li');
        if (li) {
          li.classList.add('active_filter-item');
        }
      });
    }

    function wrapperInputDeActive(inputId) {
      const inputs = wrapper.querySelectorAll(`.material_filter-wrapper label input[id="${inputId}"]`);


      inputs.forEach(input => {
        const li = input.closest('li');
        if (li) {
          li.classList.remove('active_filter-item');
        }
      });
    }

    onLoadToSetFilterActive();
    setInterval(() => {
      onLoadToSetFilterActive();
    }, 200);
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    settingLogo();
    function settingLogo() {

      const site_header_js = document.getElementById('site-header-js');
      const header__heading_logo_white = document.querySelector('.header__heading-logo-white');
      const header__heading_logo_brown = document.querySelector('.header__heading-logo-brown');

      if (window.innerWidth > 989) {
        site_header_js.classList.add('header--brown');
        site_header_js.classList.remove('header--white');

        header__heading_logo_white.classList.add('d-none');
        header__heading_logo_brown.classList.remove('d-none');
      }else{
        site_header_js.classList.remove('header--brown');
        site_header_js.classList.add('header--white');

        header__heading_logo_brown.classList.add('d-none');
        header__heading_logo_white.classList.remove('d-none');
      }
    }
    window.addEventListener('resize', settingLogo);

    // Scroll to review section when clicking on rating
    const ratingWrapper = document.querySelector('.rating-wrapper');
    if (ratingWrapper) {
      ratingWrapper.addEventListener('click', function(e) {
        e.preventDefault();

        // Try to find review section by common selectors (Judge.me, Stamped, Loox, etc.)
        const reviewSection = document.querySelector(
          '#widget-id52969, ' +
          '[id*="judgeme"], ' +
          '[id*="stamped"], ' +
          '[id*="loox"], ' +
          '[id*="review"], ' +
          '.jdgm-widget, ' +
          '.stamped-main-widget, ' +
          '.loox-reviews-default, ' +
          '.spr-container, ' +
          '.shopify-product-reviews, ' +
          '[data-reviews], ' +
          '.product-reviews'
        );

        if (reviewSection) {
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 150;
          const targetPosition = reviewSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veda-header"]) return;
  try {
    
(function () {
  var header = document.querySelector('[data-veda-header]');
  if (!header || header.dataset.vedaBound) return;
  header.dataset.vedaBound = 'true';

  var menuToggle = document.querySelector('[data-veda-menu-toggle]');
  var menuPanel = document.querySelector('[data-veda-mobile-nav]');
  var menuCloseEls = document.querySelectorAll('[data-veda-menu-close]');
  var searchToggle = document.querySelector('[data-veda-search-toggle]');
  var searchOverlay = document.querySelector('[data-veda-search-overlay]');
  var searchCloseEls = document.querySelectorAll('[data-veda-search-close]');
  var searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;

  // Sticky header, driven from JS instead of `position: sticky`. Some
  // embedding contexts (theme editor preview, certain app scripts) can
  // silently break native sticky positioning depending on how the page
  // wraps its sections; toggling `position: fixed` on scroll always
  // works regardless, since it only depends on the viewport.
  var headerSpacer = document.querySelector('[data-veda-header-spacer]');
  var headerNaturalTop = null;
  var headerIsPinned = false;

  function measureHeaderNaturalTop() {
    if (headerIsPinned) return;
    headerNaturalTop = header.getBoundingClientRect().top + window.pageYOffset;
  }

  function updateHeaderPin() {
    if (headerNaturalTop === null) measureHeaderNaturalTop();
    var shouldPin = window.pageYOffset >= headerNaturalTop;
    if (shouldPin === headerIsPinned) return;
    headerIsPinned = shouldPin;

    if (headerIsPinned) {
      if (headerSpacer) headerSpacer.style.height = header.offsetHeight + 'px';
      header.classList.add('is-pinned');
      headerSpacer && headerSpacer.classList.add('is-active');
    } else {
      header.classList.remove('is-pinned');
      headerSpacer && headerSpacer.classList.remove('is-active');
      measureHeaderNaturalTop();
    }
  }

  function resetHeaderPin() {
    header.classList.remove('is-pinned');
    headerSpacer && headerSpacer.classList.remove('is-active');
    headerIsPinned = false;
    measureHeaderNaturalTop();
    updateHeaderPin();
  }

  measureHeaderNaturalTop();
  updateHeaderPin();
  window.addEventListener('scroll', updateHeaderPin, { passive: true });
  window.addEventListener('resize', resetHeaderPin);

  function lockBodyScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    window.__lenis && window.__lenis.stop();
  }

  function unlockBodyScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    window.__lenis && window.__lenis.start();
  }

  function updateHeaderOffsetVar() {
    var top = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--veda-header-bottom', Math.max(top, 0) + 'px');
  }

  function openMenu() {
    if (!menuPanel) return;
    updateHeaderOffsetVar();
    menuPanel.hidden = false;
    requestAnimationFrame(function () {
      menuPanel.classList.add('is-open');
    });
    menuToggle && menuToggle.classList.add('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    lockBodyScroll();
  }

  function closeMenu() {
    if (!menuPanel) return;
    menuPanel.classList.remove('is-open');
    menuToggle && menuToggle.classList.remove('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    unlockBodyScroll();
    window.setTimeout(function () {
      menuPanel.hidden = true;
    }, 250);
  }

  menuToggle && menuToggle.addEventListener('click', function () {
    if (menuPanel && menuPanel.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });
  menuCloseEls.forEach(function (el) {
    el.addEventListener('click', closeMenu);
  });
  window.addEventListener('resize', function () {
    if (menuPanel && !menuPanel.hidden) {
      updateHeaderOffsetVar();
    }
    if (scrim && searchOverlay && !searchOverlay.hidden) {
      scrim.style.top = header.getBoundingClientRect().bottom + 'px';
    }
  });

  var scrim = document.querySelector('.veda-header__scrim');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    if (scrim) {
      scrim.style.top = header.getBoundingClientRect().bottom + 'px';
      scrim.classList.add('is-visible');
    }
    searchInput && searchInput.focus();
    lockBodyScroll();
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    scrim && scrim.classList.remove('is-visible');
    unlockBodyScroll();
  }

  searchToggle && searchToggle.addEventListener('click', function () {
    if (searchOverlay.hidden) {
      openSearch();
    } else {
      closeSearch();
    }
  });
  searchCloseEls.forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });

  var menuTriggers = header.querySelectorAll('.veda-header__menu-item[data-menu-key]');
  var megamenus = header.querySelectorAll('.veda-header__megamenu');
  var closeTimer = null;

  function showMegamenu(key) {
    clearTimeout(closeTimer);
    menuTriggers.forEach(function (li) {
      li.classList.toggle('is-open', li.dataset.menuKey === key);
    });
    megamenus.forEach(function (panel) {
      panel.classList.toggle('is-open', panel.dataset.megamenu === key);
    });
    if (scrim) {
      scrim.style.top = header.getBoundingClientRect().bottom + 'px';
      scrim.classList.add('is-visible');
    }
  }

  function scheduleHideMegamenu() {
    clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      menuTriggers.forEach(function (li) {
        li.classList.remove('is-open');
      });
      megamenus.forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      scrim && scrim.classList.remove('is-visible');
    }, 300);
  }

  menuTriggers.forEach(function (li) {
    li.addEventListener('mouseenter', function () {
      showMegamenu(li.dataset.menuKey);
    });
    li.addEventListener('mouseleave', scheduleHideMegamenu);
    li.addEventListener('focusin', function () {
      showMegamenu(li.dataset.menuKey);
    });
    li.addEventListener('focusout', scheduleHideMegamenu);
  });

  megamenus.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    panel.addEventListener('mouseleave', scheduleHideMegamenu);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veda-loader"] && !Shopify.designMode) return;
  try {
    
  // window.addEventListener('load', function() {
  //   document.getElementById('site-loader-js').style.display = 'none';
  //   document.querySelector('body').style.overflow = 'auto';
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-tabs')) {
    customElements.define(
      'video-tabs',
      class VideoTabs extends HTMLElement {
        constructor() {
          super();
          this.tabs = Array.from(this.querySelectorAll('[data-video-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-video-panel]'));
          this.tabsTrack = this.querySelector('[data-video-tabs-track]');
          this.tabsViewport = this.tabsTrack ? this.tabsTrack.parentElement : null;
          this.mobileQuery = window.matchMedia('(max-width: 768px)');

          if (this.tabsTrack) {
            // Delegated so marquee clones switch panels too
            this.tabsTrack.addEventListener('click', this.onTabClick.bind(this));
            this.initMarquee();
          }

          this.panels.forEach((panel) => {
            const toggleButton = panel.querySelector('[data-video-toggle]');
            const video = panel.querySelector('video');

            if (toggleButton) {
              toggleButton.addEventListener('click', this.onToggleClick.bind(this));
            }

            if (video) {
              video.addEventListener('play', () => this.setPlayingState(panel, true));
              video.addEventListener('pause', () => this.setPlayingState(panel, false));
              video.addEventListener('ended', () => this.setPlayingState(panel, false));
            }
          });
        }

        initMarquee() {
          this.updateMarquee = this.updateMarquee.bind(this);
          this.tick = this.tick.bind(this);
          this.loopDistance = 0;
          this.scrollPos = 0;
          this.userActive = false;
          this.speed = 35; // px per second
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          const pause = () => {
            this.userActive = true;
            clearTimeout(this.resumeTimer);
          };
          const resumeLater = () => {
            clearTimeout(this.resumeTimer);
            this.resumeTimer = setTimeout(() => {
              this.userActive = false;
              this.scrollPos = this.tabsViewport.scrollLeft;
            }, 2500);
          };

          this.tabsViewport.addEventListener('touchstart', pause, { passive: true });
          this.tabsViewport.addEventListener('touchend', resumeLater, { passive: true });
          this.tabsViewport.addEventListener('touchcancel', resumeLater, { passive: true });
          this.tabsViewport.addEventListener('mouseenter', pause);
          this.tabsViewport.addEventListener('mouseleave', resumeLater);
          this.tabsViewport.addEventListener('scroll', this.onTabsScroll.bind(this), { passive: true });

          if ('ResizeObserver' in window) {
            new ResizeObserver(this.updateMarquee).observe(this.tabsViewport);
          } else {
            window.addEventListener('resize', this.updateMarquee);
          }
          if (this.mobileQuery.addEventListener) {
            this.mobileQuery.addEventListener('change', this.updateMarquee);
          }
          this.updateMarquee();
          // Label widths change once the web font loads
          if (document.fonts) document.fonts.ready.then(this.updateMarquee);
        }

        updateMarquee() {
          const isMarquee = this.tabsViewport.classList.contains('is-marquee');
          // Measure with originals only
          if (isMarquee) this.disableMarquee();

          const first = this.tabs[0].getBoundingClientRect();
          const last = this.tabs[this.tabs.length - 1].getBoundingClientRect();
          const overflows = last.right - first.left > this.tabsViewport.clientWidth + 1;
          if (this.mobileQuery.matches && this.tabs.length > 1 && overflows) {
            this.enableMarquee();
          }
        }

        enableMarquee() {
          this.tabs.forEach((tab) => {
            const clone = tab.cloneNode(true);
            clone.removeAttribute('id');
            clone.removeAttribute('role');
            clone.removeAttribute('aria-controls');
            clone.removeAttribute('aria-selected');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('data-marquee-clone', '');
            this.tabsTrack.appendChild(clone);
          });

          this.tabsViewport.classList.add('is-marquee');

          // Distance from first original to its clone = exact loop length (includes gaps)
          const firstClone = this.tabsTrack.querySelector('[data-marquee-clone]');
          this.loopDistance =
            firstClone.getBoundingClientRect().left - this.tabs[0].getBoundingClientRect().left;
          this.scrollPos = this.tabsViewport.scrollLeft;

          if (!this.reducedMotion.matches && !this.rafId) {
            this.lastTime = null;
            this.rafId = requestAnimationFrame(this.tick);
          }
        }

        disableMarquee() {
          if (this.rafId) cancelAnimationFrame(this.rafId);
          this.rafId = null;
          this.loopDistance = 0;
          this.tabsTrack.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());
          this.tabsViewport.classList.remove('is-marquee');
          this.tabsViewport.scrollLeft = 0;
        }

        // Auto-scroll by driving scrollLeft, so manual swiping keeps working
        tick(time) {
          const delta = this.lastTime ? Math.min(time - this.lastTime, 100) : 0;
          this.lastTime = time;

          if (!this.userActive && !document.hidden && this.loopDistance > 0) {
            this.scrollPos += (this.speed * delta) / 1000;
            if (this.scrollPos >= this.loopDistance) this.scrollPos -= this.loopDistance;
            this.tabsViewport.scrollLeft = this.scrollPos;
          }

          this.rafId = requestAnimationFrame(this.tick);
        }

        // Keep the loop seamless in both directions while the user swipes
        onTabsScroll() {
          if (!this.loopDistance || !this.userActive) return;
          const viewport = this.tabsViewport;
          if (viewport.scrollLeft >= this.loopDistance) {
            viewport.scrollLeft -= this.loopDistance;
          } else if (viewport.scrollLeft <= 0) {
            viewport.scrollLeft += this.loopDistance;
          }
          this.scrollPos = viewport.scrollLeft;
        }

        onTabClick(event) {
          const tab = event.target.closest('[data-video-tab]');
          if (tab) this.showPanel(tab.dataset.videoTab);
        }

        showPanel(index) {
          this.tabsTrack.querySelectorAll('[data-video-tab]').forEach((tab) => {
            const isActive = tab.dataset.videoTab === index;
            tab.classList.toggle('is-active', isActive);
            if (!tab.hasAttribute('data-marquee-clone')) {
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            }
          });

          this.panels.forEach((panel) => {
            const isActive = panel.dataset.videoPanel === index;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;

            if (!isActive) {
              const video = panel.querySelector('video');
              if (video && !video.paused) video.pause();
            }
          });
        }

        onToggleClick(event) {
          const panel = event.currentTarget.closest('[data-video-panel]');
          const video = panel ? panel.querySelector('video') : null;
          if (!video) return;

          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }

        setPlayingState(panel, isPlaying) {
          panel.classList.toggle('is-playing', isPlaying);
          const button = panel.querySelector('[data-video-toggle]');
          if (button) {
            button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
